import { faUpload } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button, DashboardModule, Link } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useCampaign'
import useCampaignDocument from '@hooks/useCampaignDocument'
import useCampaignDocuments from '@hooks/useCampaignDocuments'

import { CampaignModel } from '@models/types'

import DocumentListItem from './DocumentsListItem'

interface DocumentsProps {
  campaign: CampaignModel,
  readOnly?: boolean,
}

const Documents = (props: DocumentsProps) => {
  const { campaign, readOnly } = props

  const campaignDocumentsPayload = useCampaignDocuments({
    filters: {
      campaign_id: campaign.id,
    },
    performHttpRequests: !!campaign.id,
    requestOptions: {
      include_campaign_document_file: true,
    },
  })

  const {
    filteredCampaignDocuments,
    hasFilteredCampaignDocuments,
    loading,
  } = campaignDocumentsPayload

  const {
    callbacks: {
      addCampaignDocument,
    },
  } = useCampaignDocument({ campaign_id: campaign.id })

  const { campaignEditDetailsUrl } = generateUrls({ id: campaign.id })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={
        readOnly && (
          <Link href={campaignEditDetailsUrl} textProps={{ fontSize: 'small' }}>
            Manage
          </Link>
        )
      }
      loading={loading}
      title="Documents"
    >
      <DashboardModule.ScrollableSection>
        {filteredCampaignDocuments.map(campaignDocument => (
          <DocumentListItem campaignDocument={campaignDocument} key={campaignDocument.id} readOnly={readOnly} />
        ))}
      </DashboardModule.ScrollableSection>

      {!loading && !hasFilteredCampaignDocuments && readOnly && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No documents in this campaign
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            You can add Documents in the Details page. Once added they will be included when exporting to portals.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!readOnly && (
        <DashboardModule.Footer boxProps={{ borderTop: !hasFilteredCampaignDocuments ? 'none' : '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faUpload} />}
              onClick={() => addCampaignDocument()}
              // @ts-expect-error TS2322
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Upload Document
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      )}
    </DashboardModule>
  )
}

export default Documents
